import { ShareErrorCode } from '../features/persistence/share.js';

export const VIEW_TEXT = 'Сценарий из ссылки — только просмотр. Изменения не сохраняются.';
export const ERROR_TEXT: Record<'unsupported' | 'other', string> = {
  unsupported: 'Ваш браузер не поддерживает открытие ссылок со сценарием',
  other: 'Ссылка повреждена или не содержит сценарий',
};

const CONTROLS = 'input, select, textarea, button';

export type ViewModeHandlers = { onSave: () => void; onClose: () => void };

function showBanner(text: string, withSave: boolean): void {
  const root = document.getElementById('share-banner');
  if (!root) return;
  const textEl = document.getElementById('share-banner-text');
  if (textEl) textEl.textContent = text;
  const save = document.getElementById('share-save');
  if (save) save.hidden = !withSave;
  root.hidden = false;
}

/** Binds the banner buttons once. */
export function initViewMode(handlers: ViewModeHandlers): void {
  document.getElementById('share-save')?.addEventListener('click', handlers.onSave);
  document.getElementById('share-close')?.addEventListener('click', handlers.onClose);
}

/**
 * Read-only view of a shared scenario: every control of the form and the compare button
 * are disabled and the banner explains why. Leaving the view reloads the page, so nothing
 * needs to be restored.
 */
export function enterViewMode(form: HTMLFormElement): void {
  const controls = Array.from(
    form.querySelectorAll<HTMLInputElement | HTMLButtonElement | HTMLSelectElement | HTMLTextAreaElement>(CONTROLS),
  );
  const compareCreate = document.getElementById('compare-create');
  if (compareCreate instanceof HTMLButtonElement) controls.push(compareCreate);
  controls.forEach(control => { control.disabled = true; });
  form.classList.add('is-readonly');
  showBanner(VIEW_TEXT, true);
}

/** A link that could not be opened: the banner says why, the page keeps working normally. */
export function showShareError(code: ShareErrorCode): void {
  showBanner(code === 'unsupported' ? ERROR_TEXT.unsupported : ERROR_TEXT.other, false);
}

/** Drops `#s=…` from the address bar and reloads into the normal start-up. */
export function leaveView(win: { history: History; location: Location } = window): void {
  win.history.replaceState(null, '', `${win.location.pathname}${win.location.search}`);
  win.location.reload();
}
